import {
  CURRENCIES,
  DEFAULT_CURRENCY,
  type CurrencyCode,
  type CurrencyConfig,
} from '@/shared/types/currency.types';

export function getCurrencyConfig(code: CurrencyCode = DEFAULT_CURRENCY): CurrencyConfig {
  return CURRENCIES[code] ?? CURRENCIES[DEFAULT_CURRENCY];
}

/** Formate un montant selon la devise (ex: 45000 → "45 000 GNF") */
export function formatAmount(
  amount: number | string | null | undefined,
  currency: CurrencyCode = DEFAULT_CURRENCY,
  options?: { compact?: boolean; showSymbol?: boolean },
): string {
  const config = getCurrencyConfig(currency);
  const num = typeof amount === 'string' ? parseFloat(amount.replace(/\s/g, '').replace(',', '.')) : (amount ?? 0);
  if (isNaN(num)) return options?.showSymbol === false ? '0' : `0 ${config.symbol}`;

  const formatted = new Intl.NumberFormat(config.locale, {
    minimumFractionDigits: config.decimals,
    maximumFractionDigits: config.decimals,
    notation: options?.compact ? 'compact' : 'standard',
  }).format(num);

  if (options?.showSymbol === false) return formatted;
  return `${formatted} ${config.symbol}`;
}

/** Parse une saisie utilisateur en nombre */
export function parseAmount(value: string): number {
  const cleaned = value.replace(/[^\d.,-]/g, '').replace(',', '.');
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
}

/** Formate pour affichage dans un input (sans symbole) */
export function formatAmountInput(value: number | string, currency: CurrencyCode = DEFAULT_CURRENCY): string {
  const config = getCurrencyConfig(currency);
  const num = typeof value === 'string' ? parseAmount(value) : value;
  if (!num) return '';
  return new Intl.NumberFormat(config.locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: config.decimals,
  }).format(num);
}

export function isValidCurrency(code: string): code is CurrencyCode {
  return code in CURRENCIES;
}
